<template>
  <div class="container-fluid text-left">
	<div class="row">
	  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mb-2">
		<div class="card">
		  <div class="card-header bg-info text-white">
			<span class="fa fa-info-circle mr-2" style="font-size:1.3em;vertical-align:middle;"></span>
			Información
		  </div>
		  <div class="card-body bg-light">
			<p>
			  Antes de continuar debes haber realizado los siguientes pasos:
			  <ol>
				<li>Haber <b>creado el cliente</b></li>
				<li>Haber <b>creado el anunciante</b></li>
				<li>Haber <b>creado el contrato</b> de esta campaña</li>
			  </ol>
			</p>
			<p>
			  Es necesario que todas las cuñas tengan un contrato asociado para poder
			  extraer correctamente las analíticas de seguimiento y de rendimiento de las
			  campañas.
			</p>
		  </div>
		</div>
	  </div>
	  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-2">
		<div class="card">
		  <div class="card-header bg-light">
			<span class="fa fa-edit mr-2" style="font-size:1.3em;vertical-align:middle;"></span>
			Datos de la campaña
		  </div>
		  <div class="card-body">
			<div class="form-group" v-if="!produccion.anunciante.ID_anunciante">
			  <label for="">Anunciante</label>
			  <input-query :realtime="true" :input-class="'form-control form-control-sm'" placeholder="Busca el anunciante" :url="'/produccion/php/api/buscaAnunciante.php'" @selected="seleccionaAnunciante($event)"></input-query>
			</div>
			<div v-if="produccion.anunciante.ID_anunciante">
			  <b>Anunciante:</b>
			  <div class="input-group input-group-sm">
				<input type="text" disabled v-model="produccion.anunciante.nombre" class="form-control form-control-sm">
				<div class="input-group-btn">
				  <button class="btn btn-sm btn-danger" @click="quitaAnunciante">
					<span class="fa fa-trash"></span>
				  </button>
				</div>
			  </div>
			</div>
		  </div>
		  <div class="card-body bg-danger text-white text-center" v-if="produccion.anunciante.ID_anunciante">
			<div v-if="produccion.contrato.ID_contrato">
			  <b>Contrato asociado</b>
			  <br>
			  <h5>{{produccion.contrato.nombreCliente}}</h5>
			  <h6>{{produccion.contrato.titulo}}</h6>
			  <button class="btn btn-dark btn-sm" @click="asociando = true">
				<span class="fa fa-gear"></span>
				Cambiar contrato
			  </button>
			</div>
			<div class="text-center" v-if="!produccion.contrato || !produccion.contrato.ID_contrato">
			  <button class="btn btn-dark btn-sm" @click="asociando = true">
				<span class="fa fa-gear"></span>
				Asociar contrato
			  </button>
			</div>
		  </div>
		  <div class="card-body" v-if="produccion.contrato.ID_contrato">
			<div class="form-group">
			  <label for="">Título de la campaña</label>
			  <input type="text" class="form-control form-control-sm" placeholder="Escribe el título" v-model="produccion.titulo">
			</div>
		  </div>
		</div>
	  </div>
	  <div class="col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-4 mb-2">
		<div class="card" v-if="esValido">
		  <div class="card-header bg-dark text-white">
			<span class="fa fa-file-o mr-2" style="font-size:1.3em;vertical-align:middle;"></span>
			Selección de ficheros
			<button class="btn btn-sm btn-warning pull-right" @click="seleccionaFicheros">
			  <span class="fa fa-upload"></span>
			</button>
		  </div>
		  <table class="table table-striped m-0">
			<tbody>
			  <tr v-for="(fichero, index) in ficheros" :key="fichero.name">
				<td style="vertical-align:middle;">
					<span title="Contiene fonográmas protegidos por derechos de autor" v-if="fichero.musica_autor === 1" class="fa fa-copyright" style="font-size:2em;"></span>
					<span title="No contiene fonográmas protegidos por derechos de autor" v-else class="fa fa-gift" style="font-size:2em;"></span>
				</td>
				<td style="vertical-align:middle;">{{fichero.fichero.name}}</td>
				<td style="vertical-align:middle;">{{getTamano(fichero.fichero.size)}}</td>
				<td style="vertical-align:middle;" class="text-right">
				  <button class="btn btn-sm btn-danger" @click="quitaFichero(index)">
					<span class="fa fa-trash"></span>
				  </button>
				</td>
			  </tr>
			</tbody>
		  </table>
		  <div class="card-footer" v-if="ficheros.length > 0">
			<button class="btn btn-sm btn-primary" @click="subirFicheros()">
			  Subir ficheros
			</button>
		  </div>
		</div>
	  </div>
	</div>
	<asocia-contrato v-if="asociando" @cerrar="asociando = false" @asignar="asociaContrato"></asocia-contrato>
  </div>
</template>

<script>
import AsociaContrato from '../../../produccion/vue/components/nueva/asocia-contrato'

export default {
	name: 'subir-cunas',
	components: {
		'asocia-contrato': AsociaContrato
	},
	data () {
		return {
			produccion: null,
			ficheros: [],
			asociando: false
		}
	},

	created () {
		this.nuevaProduccion()
	},
	computed: {
		esValido () {
			return (this.produccion.anunciante.ID_anunciante && this.produccion.contrato.ID_contrato && this.produccion.titulo)
		}
	},

	methods: {
		getTamano (size) {
			let bytes = size
			const si = true
			var thresh = si ? 1000 : 1024
			if (Math.abs(bytes) < thresh) {
				return bytes + ' B'
			}
			var units = si
				? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
				: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
			var u = -1
			do {
				bytes /= thresh
				++u
			} while (Math.abs(bytes) >= thresh && u < units.length - 1)

			return bytes.toFixed(1) + ' ' + units[u]
		},
		nuevaProduccion () {
			this.produccion = {
				ID_produccion: null,
				titulo: null,
				publica: 0,
				contrato: {
					ID_contrato: null,
					titulo: null,
					nombreCliente: null
				},
				anunciante: {
					ID_anunciante: null,
					nombre: null
				},
				descripcion: null,
				agente: {
					ID: null,
					nombre: null
				},
				ficheros: [],
				tareas: []
			}

			this.ficheros = []
		},
		seleccionaAnunciante (e) {
			this.produccion.anunciante = {
				ID_anunciante: e.datos.ID_anunciante,
				nombre: e.datos.nombre
			}
		},

		quitaAnunciante () {
			this.produccion.anunciante.ID_anunciante = null
			this.produccion.contrato.ID_contrato = null
		},

		asociaContrato (e) {
			this.produccion.contrato = {
				ID_contrato: e.ID_contrato,
				titulo: e.titulo,
				nombreCliente: e.nombreCliente
			}

			this.asociando = false
		},
		quitaFichero (i) {
			this.ficheros.splice(i, 1)
		},

		seleccionaFicheros () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Derechos de autor',
				mensaje: `<b>Importante</b>
				Es necesario que especifiques si el o los ficheros que vas a adjuntar contienen música protegida por derechos de autor.
				<b>¿Tienen derechos de autor?</b>`,
				buttons: [
					{
						titulo: 'Sí',
						clase: 'btn btn-sm btn-primary',
						icono: 'fa fa-check',
						valor: 1
					},
					{
						titulo: 'No',
						clase: 'btn btn-sm btn-danger',
						icono: 'fa fa-ban',
						valor: 0
					}
				],
				callback: tieneDerechos => {
					this.seleccionaFicherosFase2(tieneDerechos)
				}
			})
		},

		seleccionaFicherosFase2 (derechos) {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.multiple = true
			inp.style.display = 'none'
			inp.accept = '.mp3,audio/mpeg'

			inp.addEventListener('change', (e) => {
				for (let i = 0; i < inp.files.length; i++) {
					let encontrado = false
					for (let f = 0; f < this.ficheros.length; f++) {
						if (inp.files[i].name === this.ficheros[f].fichero.name) {
							encontrado = true
						}
					}

					if (!inp.files[i].name.match(/\.mp3$/i)) {
						encontrado = true
						this.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: 'El fichero ' + inp.files[i].name + ' no es un fichero mp3'
						})
					}

					if (!encontrado) {
						this.ficheros.push({
							musica_autor: derechos,
							fichero: inp.files[i]
						})
					}
				}

				inp.parentElement.removeChild(inp)
			})
			document.body.appendChild(inp)
			inp.click()
		},

		subirFicheros () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Subir ficheros',
				mensaje: '¿Deseas subir estos ficheros con los datos proporcionados?\nEsto implica que el anunciante y el contrato son correctos.',
				callback: (acepta) => {
					if (acepta) {
						const form = new FormData()
						form.append('datos', JSON.stringify(this.produccion))

						for (let i = 0; i < this.ficheros.length; i++) {
							form.append('musica_autor[]', this.ficheros[i].musica_autor)
							form.append('ficheros[]', this.ficheros[i].fichero)
						}

						this.$http.post('subir-cunas/php/api/subir.php', form)
							.then(res => {
								this.$store.commit('alertas/alert', {
									titulo: 'Subido',
									mensaje: 'Archivos subidos correctamente'
								})

								this.nuevaProduccion()
							})
							.catch(e => {
								this.$store.commit('alertas/alert', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/modulos/subir-cunas/vue/components/Main.vue